import {ResourceType} from '../../../../@types/resource-type';
import {ExplorerTableConfig, ResourceTypeConfig} from './explorer-mrt-types';

// Default resource type configurations
const defaultResourceConfigs: Partial<Record<ResourceType, ResourceTypeConfig>> = {
    [ResourceType.GROUPS]: {
        iconColor: 'primary',
        chipColor: 'primary',
        displayName: 'Working Area',
    },
    [ResourceType.SAFETY_MODELS]: {
        iconColor: 'success',
        chipColor: 'success',
        displayName: 'Safety Model',
    },
    [ResourceType.EVENT_SEQUENCES]: {
        iconColor: 'info',
        chipColor: 'info',
        displayName: 'Safety View',
    },
    [ResourceType.COMPONENT]: {
        iconColor: 'secondary',
        chipColor: 'secondary',
        displayName: 'Component',
    },
    [ResourceType.WORKSHOPS]: {
        iconColor: 'warning',
        chipColor: 'warning',
        displayName: 'Workshop',
    },
    [ResourceType.RISK_FORECASTS]: {
        iconColor: 'error',
        chipColor: 'secondary',
        displayName: 'Risk Forecast',
    },
    [ResourceType.OPERATIONAL_CHANGES]: {
        iconColor: 'info',
        chipColor: 'info',
        displayName: 'Operational Change',
    },
    [ResourceType.OCCURRENCE_REPORTS]: {
        iconColor: 'warning',
        chipColor: 'warning',
        displayName: 'Occurrence Report',
    },
    [ResourceType.OCCURRENCE_REPORT_DESCRIPTORS]: {
        iconColor: 'info',
        chipColor: 'info',
        displayName: 'Report Descriptor',
    },
    [ResourceType.PERFORMANCE_SHAPING_FACTORS]: {
        iconColor: 'secondary',
        chipColor: 'secondary',
        displayName: 'PSF Template',
    },
    [ResourceType.USERS]: {
        iconColor: 'primary',
        chipColor: 'primary',
        displayName: 'User',
    },
    [ResourceType.SERVICE_USER_ACCOUNTS]: {
        iconColor: 'info',
        chipColor: 'default',
        displayName: 'Service User',
    },
    [ResourceType.INTEGRATED_RISK_PICTURES]: {
        iconColor: 'info',
        chipColor: 'info',
        displayName: 'Integrated Risk Picture',
    },
};

// Configuration presets for different views
export const tableConfigs: Record<string, ExplorerTableConfig> = {
    safetyModels: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: true,
        enableLazyLoading: true,
    },
    workshops: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    riskForecasts: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    operationalChanges: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    groups: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    occurrenceReports: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    occurrenceReportDescriptors: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    performanceShapingFactors: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    users: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    serviceUsers: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: true,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    integratedRiskPictures: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: false,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
    datasets: {
        resourceTypes: defaultResourceConfigs,
        showGroupRole: false,
        showSequenceCount: false,
        enableLazyLoading: false,
    },
};

export const getResourceConfig = (
    type: ResourceType,
    config: ExplorerTableConfig | undefined
): ResourceTypeConfig | undefined => {
    return config?.resourceTypes[type];
};